import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import WATesting from "../assets/WebAppTesting.jpg";

function WebAppTesting() {
  const { t } = useTranslation();
  const textContainerRef = useRef(null);
  const [textHeight, setTextHeight] = useState(0);

  const testingItems = Array.from({ length: 7 }, (_, index) => ({
    title: t(`wa_testing_title_${index + 1}`), // Translated title
    description: t(`wa_testing_description_${index + 1}`), // Translated description
  }));

  useEffect(() => {
    if (textContainerRef.current) {
      setTextHeight(textContainerRef.current.offsetHeight);
    }
  }, [testingItems]);

  return (
    <>
      <Box display="flex" justifyContent="center">
        <Typography variant="h5" fontWeight={500}>
          {t("wa_testing_heading")}
        </Typography>
      </Box>
      <Grid
        container
        sx={{
          py: 3,
          px: { xs: 2, sm: 8, lg: 30 },
          pb: 5,
          gap: { xs: 5, md: 0 },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {/* Text Section */}
        <Grid
          item
          xs={12}
          md={6}
          display={"flex"}
          direction={"column"}
          sx={{ pr: 2 }}
          order={{ xs: 2, md: 1 }} // Preserve original order
          ref={textContainerRef} // Reference to calculate text height
        >
          {/* Description without bullet */}
          <Typography variant="body2" color="text.secondary">
            {t("wa_testing_description")}
          </Typography>
          <List sx={{ ml: 3 }}>
            {testingItems.map((item, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "block", mb: 2 }}
              >
                {/* Title as bold with bullet */}
                <Typography variant="body1">&#8226; {item.title}</Typography>
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Image Section */}
        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Box
            component="img"
            src={WATesting}
            alt="Benefits"
            sx={{
              maxWidth: { xs: "100%", md: "95%" },
              height: { xs: "auto", md: `${textHeight}px` }, // Dynamically set height
              objectFit: "cover", // Ensures the image fits the height
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default WebAppTesting;
